import { Tabs, Tab, Box } from "@mui/material";
import { Link, useLocation, matchPath } from "react-router-dom";

const OrdersTopNav = () => {
  const location = useLocation();

  const routes = [
    { path: "/orders", label: "All Orders", exact: true },
    { path: "/orders/processing", label: "Processing" },
    { path: "/orders/booking", label: "Booking" },
    { path: "/orders/paid", label: "Paid" },
  ];

  const currentTab = routes.findIndex((route) => {
    return route.exact
      ? location.pathname === route.path
      : matchPath({ path: route.path, end: false }, location.pathname);
  });

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={currentTab !== -1 ? currentTab : false}
        aria-label="Orders navigation tabs"
      >
        {routes.map((route) => (
          <Tab
            key={route.path}
            label={route.label}
            component={Link}
            to={route.path}
            aria-current={currentTab !== -1 ? "page" : undefined}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default OrdersTopNav;
